import twitterIcon from '../../assets/twitter.png' 
import linkedinIcon from '../../assets/linkedin.png'

function TeamMemberProfile({team_member}) {
  return (
    <li>
        <div>
            <img loading='lazy' src={team_member.image} alt={`${team_member.full_name}'s profile pic`} />
        </div>
        <p>{team_member.full_name}</p>
        <small>{team_member.role}</small>
        <div>
          <a href="https://twitter.com/tomisnakinwande"><img src={twitterIcon} alt="twitter icon" /></a>
          <a href="https://www.linkedin.com/in/tomisin-akinwande-981842247/"><img src={linkedinIcon} alt="linkedin icon" /></a>
        </div>
    </li>
  )
}


export default TeamMemberProfile